import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getLocation: (state) => () => {
    return state.all
  }
}

const actions = {
  fetchAll ({ commit }) {
    return new Promise((resolve) => {
      api.getLocation()
        .then(data => {
          commit('setlocations', data)
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setlocations(state, data) {
    Object.assign(state.all, data)
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
